import {connect} from '../../../../../../../commons/components/runtime-context/connect'
import {isChooseSeatMode} from '../../../../selectors/navigation'
import {DetailsPageAppProps} from '../../../app/interfaces'
import {TicketOwnProps, TicketRuntimeProps} from './interfaces'
import {Ticket as Presentation} from './ticket'

const mapRuntime = ({state}: DetailsPageAppProps): TicketRuntimeProps => ({
  chooseSeatMode: isChooseSeatMode(state),
})

export const Ticket = connect<TicketOwnProps, TicketRuntimeProps>(mapRuntime)(Presentation)

export * from './interfaces'
